<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex xs12 sm6 d-flex mb-2>
        <v-text-field
            v-model="query"
            append-icon="search"
            :label="trans('app.search.search')"
            single-line
            hide-details
            solo
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
        :disable-initial-sort="true"
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="isLoading"
        :rows-per-page-items="[10,25,50,100]"
        :no-data-text="trans('app.search.no_data')"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td style="width: 45%">{{ props.item.last_name }}</td>
          <td style="width: 45%">{{ props.item.first_name }}</td>
          <td>
            <icon-button
                icon="person"
                color="blue"
                :tooltip="{attach: false}"
                :iconOptions="{small: true}"
                @click="selectPatient(props.item)"
                :permission="!!props.item.has_interview"
                :no-permission-tool-tip="'app.import_schema_into_patient.fill_the_interview'"
            >
              {{ 'app.import_schema_into_patient.import_button' | trans }}
            </icon-button>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {trans} from "../../app";
import debounce from "lodash/debounce";
import axios from 'axios';

export default {
  data: function () {
    return {
      query: null,
      headers: [
        {
          text: trans('app.surname'), align: 'left', value: 'last_name', sortable: true,
        },
        {
          text: trans('app.first_name'), align: 'left', value: 'first_name', sortable: true,
        }
      ],
      items: [],
      pagination: {},
      total: 0,
      isLoading: false,
      debounceFetch: null
    };
  },
  methods: {
    makeParams: function () {
      return {
        search: this.query,
        orderBy: this.pagination.sortBy ? this.pagination.sortBy : null,
        dir: this.pagination.hasOwnProperty('descending') && this.pagination.descending ? 'desc' : 'asc',
        perPage: this.pagination.rowsPerPage ? this.pagination.rowsPerPage : 50,
        searchByName: true,
        page: this.pagination.page ? this.pagination.page : 1,
      }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const {data} = await axios.get('/patients/data', {
          params: this.makeParams()
        });

        this.items = data.data;
        this.total = data.meta.total;
        this.pages = data.meta.last_page;
        this.isLoading = false;
      } catch (e) {
        this.$toast.error('app.error_occurred');

        throw e;
      }
    },
    close() {
      this.query = null;
    },
    selectPatient(patient) {
      this.$emit('patientSelected', patient);
    }
  },
  watch: {
    query: {
      handler() {
        this.debounceFetch();
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.debounceFetch();
      }
    },
  },
  created() {
    this.debounceFetch = debounce(this.fetchData, 300);
  },
}
</script>

<style scoped>

</style>
